/* eslint-disable sciencepo-rules/require-story*/
/* Ce test plus facilement avec son parent*/
import React from 'react';
import { Script } from 'gatsby';
import * as youtubeStyles from '../../../../styles/widgets/youtube.module.scss';
import dompurify from 'isomorphic-dompurify';
import PropTypes from 'prop-types';
import {dompurifyConfig} from '../../../../utils/utils';

export const EmbeddedContent = ({ content }) => {
  const [scriptContent, setScriptContent] = React.useState('');
  const [scriptSource, setScriptSource] = React.useState('');
  const sanitizer = dompurify.sanitize;
  const contentRef = React.useRef(null);

  React.useEffect(() => {
    setScriptSource(contentRef?.current?.querySelector('script')?.src);
    setScriptContent(
      contentRef?.current?.querySelector('script')?.firstChild?.textContent
    );

    // use to set flickr content size
    const image = contentRef.current?.querySelector('img');
    if (image) {
      image.removeAttribute('width');
      image.removeAttribute('height');
      image.setAttribute('style', 'height: 100%; width: 100%;');
    }
  }, []);

  return (
    <div className={youtubeStyles.bloc}
      role="presentation"
    >
      {scriptContent && (
        <Script>{scriptContent}</Script>
      )}
      {scriptSource && (
        <Script async
          src={scriptSource}
        />
      )}
      <div
        className={youtubeStyles.contentBackground}
        dangerouslySetInnerHTML={{ __html: sanitizer(content.html, dompurifyConfig) }}
        ref={contentRef}
      />
    </div>
  );
};

EmbeddedContent.propTypes = {
  content: PropTypes.shape({
    html: PropTypes.string.isRequired,
  }),
};